import api from 'jsApi/CommandApi';
import { getCurrentProjectId } from 'jsModels/Organization';

export const fetchTagsRequest = async () =>
  api.fetchTags({
    projectId: getCurrentProjectId()
  });

export const updateTagRequest = async tag => api.updateTag(tag);
